import React, { Component } from 'react'
import PropTypes from 'prop-types'
import compose from '@shopify/react-compose'
import { withTranslation } from 'react-i18next'
import i18next from 'i18next'

import Dashboard from './dashboard-view'

import { getRunningTickets, getActiveAdvertisement } from '@portal/kit/pkg/services'
import { withConfiguration, withEndUser, withPreview, AppLoader, FormError } from '@portal/kit/pkg/components'
import { i18nAdvertisement } from '@portal/kit/pkg/helpers'

import { isRanEligible } from 'helpers/ran'
import { withRan } from 'components/providers/ran'

class DashboardContainer extends Component {
  state = {
    runningTickets: null,
    advertisement: null
  }

  ranEnabled = () => isRanEligible(this.props)

  ranActivated = () => {
    const rooms = this.props.getRooms()
    return rooms.length > 0
  }

  hasAdvertisements = () => {
    return this.props.portalConfiguration.has_advertisements
  }

  componentDidMount() {
    getRunningTickets()
      .then(response => this.setState({ runningTickets: response.data }))
      .catch(e => this.setState({ globalError: this.props.t('form.error') }))

    if (this.hasAdvertisements()) {
      getActiveAdvertisement()
        .then(response => this.setState({ advertisement: response.data }))
    }
  }

  render() {
    const rooms = this.props.getRooms()
    const isFetching = this.props.isFetching()

    const { globalError: globalErrorProps } = this.props
    const { advertisement, globalError, runningTickets } = this.state

    if (globalError) {
      return <FormError message={globalErrorProps || globalError} />
    }

    if (runningTickets === null || (this.ranEnabled() && isFetching)) {
      return <AppLoader />
    }

    return (
      <Dashboard
        {...this.props}
        runningTickets={runningTickets}
        ranEnabled={this.ranEnabled()}
        ranActivated={this.ranActivated()}
        rooms={rooms}
        advertisement={i18nAdvertisement(advertisement, i18next.language)}
      />
    )
  }

}

DashboardContainer.propTypes = {
  portalConfiguration: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  getRooms: PropTypes.func,
  globalError: PropTypes.string
}

export default compose(
  withPreview,
  withConfiguration,
  withEndUser,
  withRan,
  withTranslation(),
)(DashboardContainer)
